var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{ref:"dlg",attrs:{"title":"Select Location","closeable":"true"}},[_c('div',{staticClass:"location-tree-modal"},[_c('LocationsTree',{model:{value:(_vm.geoLocation),callback:function ($$v) {_vm.geoLocation=$$v},expression:"geoLocation"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0cc2820","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ssp/LocationTreeModal.vue
// module id = null
// module chunks = 